
import PropTypes from 'prop-types';
import React from 'react';
import { Modal} from 'react-bootstrap';
import Layout from '../../../components/Layout';
import BrandManagerHome from './BrandManagerHome';
import HotelManagerHome from './HotelManagerHome';
import MobileHome from './MobileHome';
import NoRoleHome from './NoRoleHome';
import TourManagerHome from './TourManagerHome';
import TravelManagerHome from './TravelManagerHome';
import BrandInfo from './BrandInfo';


class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopUp : false,
      brandinfo : null,
      contacts : null,
    };
    this.BrandPopUp = this.BrandPopUp.bind(this);
    this.OnClose = this.OnClose.bind(this);
  }
  componentDidMount() {
    this.props.requestBrands();
    this.props.getBrandContacts();
  }
  BrandPopUp(brand,contact){
    this.setState({
      showPopUp:true,
      brandinfo:brand,
      contacts:contact,
    });
  }
  OnClose(){
    this.setState({showPopUp:false});
  }

  render() {
    if (this.props.perms.includes('travel_management')){
      return (
        <Layout>
          <TravelManagerHome 
            requestCatchNews={this.props.requestCatchNews} 
            requestCatchPartnerSpecials={this.props.requestCatchPartnerSpecials}
            requestCatchAnnouncementsConfig={this.props.requestCatchAnnouncementsConfig}
            catchNews={this.props.catchNews}
            catchPartnerSpecials={this.props.catchPartnerSpecials}
            catchAnnouncementsConfig={this.props.catchAnnouncementsConfig}
            BrandPopUp = {this.BrandPopUp}
            brands ={this.props.brands}
            brandsContacts ={this.props.brandsContacts}
          />
          <div>
            <Modal bsSize="large" show={this.state.showPopUp} onHide={()=>this.OnClose()}>
                <Modal.Header closeButton>
                  <Modal.Title>Brand Details : ({this.state.brandinfo?this.state.brandinfo.name:''}) </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <BrandInfo brand={this.state.brandinfo} contacts={this.state.contacts}/>
                </Modal.Body>
                <Modal.Footer >
                  <p></p>
                </Modal.Footer>
            </Modal>
          </div>
        </Layout>
      )
    } 
    if (this.props.perms.includes('brand_management')){
      return (
        <Layout>
          <BrandManagerHome />
        </Layout>
      );
    }
    if (this.props.perms.includes('hotel_management')){
      return (
        <Layout>
          <HotelManagerHome />
        </Layout>
      );
    }
    if (this.props.perms.includes('tour_management')){
      return (
        <Layout>
          <TourManagerHome />
        </Layout>
      );
    }
    if (this.props.perms.includes('mobile_access')){
      return (
        <Layout>
          <MobileHome />
        </Layout>
      );
    }
    return (
      <Layout>
        <NoRoleHome />
      </Layout>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// src/routes/home/components/Home.js